import { FLAG } from '../constants/patientChart.constant';

export const useFlagsValidation = ({
  orderFlags = [],
  prescriberFlags = [],
  flag = FLAG(),
}) => {
  const noOfRequiredFlags = orderFlags.length + prescriberFlags.length;

  const requiredInputs = new Set(['']);
  requiredInputs.delete('');
  orderFlags.forEach(({ flagId }) => {
    requiredInputs.add(`0-${flagId}`);
  });
  prescriberFlags.forEach(({ productId, flagId }) => {
    requiredInputs.add(`${productId}-${flagId}`);
  });

  const foundInputs = FLAG().input;
  requiredInputs.forEach((key) => {
    if (flag.input.has(key)) {
      foundInputs.set(key, flag.input.get(key));
    }
  });

  let noOfAnsweredFlags = 0;
  foundInputs.forEach(({ note }) => {
    if (note.length > 0) {
      noOfAnsweredFlags++;
    }
  });

  return { noOfRequiredFlags, noOfAnsweredFlags };
};

export default useFlagsValidation;
